"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _errorMessage = _interopRequireDefault(require("./error-message.scss"));

var _fieldsize = _interopRequireWildcard(require("./fieldsize"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ErrorMessage = function ErrorMessage(_ref) {
  var _cx;

  var size = _ref.size,
      message = _ref.message,
      className = _ref.className,
      ariaLive = _ref.ariaLive;
  return _react["default"].createElement("span", {
    className: (0, _classnames["default"])(_errorMessage["default"].ErrorMessage, (_cx = {}, (0, _defineProperty2["default"])(_cx, _errorMessage["default"].ErrorMessageDefault, size === _fieldsize["default"].DEFAULT), (0, _defineProperty2["default"])(_cx, _errorMessage["default"].ErrorMessageSmall, size === _fieldsize["default"].SMALL), _cx), className),
    "aria-live": ariaLive
  }, message);
};

ErrorMessage.defaultProps = _objectSpread({}, _fieldsize.fieldSizeDefaultProps, {
  ariaLive: 'polite'
});
ErrorMessage.propTypes = _objectSpread({}, _fieldsize.fieldSizePropTypes, {
  message: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,
  ariaLive: _propTypes["default"].oneOf(['off', 'polite', 'assertive'])
});
var _default = ErrorMessage;
exports["default"] = _default;